<template>
  <v-dialog
      v-model="show"
      :max-width="'450px'"
      persistent
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Material wählen</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-row style="margin: 0">
              <v-text-field
                  v-model="search_arti"
                  prepend-icon="mdi-magnify"
                  label="Suchen"
                  single-line
                  hide-details
                  clearable
              ></v-text-field>
            </v-row>
            <v-list                 style="max-height: 45vh; min-height: 45vh; overflow-y: auto"
            >
              <v-list-item-group
                  v-model="selectedArtis"
                  multiple
                  color="indigo"
              >
                <template v-for="(group, i) in myList">
                  <v-divider v-if="group.title" style="border-color: rgba(0,0,0,0.46)"></v-divider>
                  <v-subheader v-if="group.title" style="margin-left: -16px">{{ group.title }}</v-subheader>
                  <v-list-item
                      v-for="(item, i) in group.items"
                      :key="item.access"
                      :value="item.access"
                      :style="{
                        'border-bottom': i === group.items.length - 1 ? 'none': 'rgba(128,128,128,0.25) thin solid',
                      }"
                  >
                    <v-list-item-content>
                      <v-list-item-title v-text="item.name"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-list-item-group>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            v-on:click.stop="show = false"
        >
          Abbrechen
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            :disabled="selectedArtis.length === 0"
            v-on:click.stop="sendResult"
        >
          Auswählen
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog
        v-model="showCount"
        :max-width="'300px'"
        persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Menge wählen</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
              label=""
              v-model="currentCount"
              :suffix="currentUnit"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              v-on:click.stop="cancelCounter"
          >
            Abbrechen
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              :disabled="!currentCount.replace(/[^0-9,-.]/g, '').replace(',','.') || parseFloat(currentCount.replace(/[^0-9,-.]/g, '').replace(',','.')) <= 0"
              v-on:click.stop="saveCounter"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>

</template>

<script>
export default {
  name: "SelectArtisDialog",
  props: {
    artis: {
      type: Array,
      default: () => []
    },
    categories: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    myList() {
      // first apply the search filter
      let filtered = this.artis;
      if (this.search_arti && this.search_arti.length > 0) {
        const search = this.search_arti.toLowerCase();
        filtered = filtered.filter(arti => arti.name.toLowerCase().includes(search));
      }
      let rest = {
        title: 'Weiteres Material',
        items: []
      }
      let list = [];
      let cats = this.categories || [];
      for (let i = 0; i < filtered.length; i++) {
        let cur = filtered[i];
        let catIndex = cats.findIndex(cat => cat.value === cur.access);
        // first check if in currentLeistMapping
        if (catIndex !== -1) {
          let cat = cats[catIndex];
          let catListIndex = list.findIndex(l => l.title === cat.key);
          if (catListIndex === -1) {
            list.push({
              title: cat.key,
              items: [cur]
            });
          } else {
            list[catListIndex].items.push(cur);
          }
        } else {
          rest.items.push(cur);
        }
      }
      // order list by text
      list.sort((a, b) => a.title.localeCompare(b.title));
      // append rest
      if (list.length === 0) {
        rest.title = '';
      }
      if (rest.items.length > 0) {
        list.push(rest);
      }
      return list;
    },
  },
  watch: {
    selectedArtis(newVal, oldVal) {
      // check if we have deletion or addition
      if (newVal.length < oldVal.length) {
        // deletion
        let deleted = oldVal.filter(x => !newVal.includes(x));
        for (let i = 0; i < deleted.length; i++) {
          delete this.counts[deleted[i]];
        }
      } else {
        // addition
        let added = newVal.filter(x => !oldVal.includes(x));
        for (let i = 0; i < added.length; i++) {
          this.currentAddition = added[i];
          this.currentCount = '1,00';
          this.currentUnit = '';
          let arti = this.artis.find(a => a.access === added[i]);
          if (arti && arti.unit) {
            this.currentUnit = arti.unit;
          }
          // todo show dialog to ask for count
          this.showCount = true;
          break;
        }
      }
    }
  },
  data: () => ({
    selectedArtis: [],
    counts: {},
    show: false,
    search_arti: '',
    currentAddition: null,
    showCount: false,
    currentCount: '1,00',
    currentUnit: '',
  }),
  methods: {
    openDialog() {
      this.selectedArtis = [];
      this.counts = {};
      this.show = true;
    },
    saveCounter() {
      // make text to number conversion also replace alphabetic with nothing
      this.counts[this.currentAddition] = parseFloat(this.currentCount.replace(/[^0-9,-.]/g, '').replace(',','.'));
      this.showCount = false;
    },
    cancelCounter() {
      // remove from selectedArtis
      let index = this.selectedArtis.findIndex(a => a === this.currentAddition);
      if (index !== -1) {
        this.selectedArtis.splice(index, 1);
      }
      this.showCount = false;
    },
    sendResult() {
      this.show = false;
      let result = [];
      for (let i = 0; i < this.selectedArtis.length; i++) {
        let access = this.selectedArtis[i];
        let count = this.counts[access];
        result.push({
          access: access,
          count: count
        });
      }
      this.$emit('save', result);
    }
  }



}
</script>

<style scoped>
::v-deep .v-list-item__content {
  padding: 0px 0;
}

::v-deep .v-list-item {
  min-height: 34px;
}

::v-deep .v-subheader {
  height: 24px;
  font-weight: 500;
}

::v-deep .v-divider {
  margin-bottom: 6px;
  margin-top: 6px;
}

</style>
